import React from 'react';
import s from './SophisticatedTooltipText.scss';
var SophisticatedTooltipText = function (_a) {
    var children = _a.children;
    return React.createElement("span", { className: s['root'] }, children);
};
SophisticatedTooltipText.displayName = 'SophisticatedTooltipText';
export default SophisticatedTooltipText;
//# sourceMappingURL=SophisticatedTooltipText.js.map